import { MBText } from '@shared/components/MBText';
import { View } from '@shared/components/View';
import { MBUserImage } from '@shared/components/image';
import { MBScrollView } from '@shared/components/scrollview';
import { API } from '@shared/types/api';
import { ListStyles } from './styles';
import { getReactionEmoji } from './types';

export interface MBReactionListProps {
  reactions: API.ReactionFragment[];
}

// TODO(fant): use MBFlatList instead of MBScrollView. Need to upgrade to RN 0.56 first
// https://github.com/facebook/react-native/issues/19466
export function MBReactionList({ reactions }: MBReactionListProps) {
  return (
    <MBScrollView style={ListStyles.container}>
      <View padding={1}>
        {/* compensate for row item paddingBottom */}
        <View paddingTop={1} />
        {reactions.map((reaction, index) => (
          <View key={index} row centerVertically paddingBottom={1}>
            <MBUserImage size="small" user={reaction.user} style={ListStyles.image} />
            <View paddingRight={1} />
            <MBText size="large">{reaction.user.fullName}</MBText>
            <View paddingRight={1} />
            <MBText style={ListStyles.emoji}>{getReactionEmoji(reaction.type)}</MBText>
          </View>
        ))}
      </View>
    </MBScrollView>
  );
}
